import web6 from "../../../assets/images/web-designer/img-6.jpg";
import web7 from "../../../assets/images/web-designer/img-7.jpg";
import { faqContent } from "../data";
import { cn } from "../../../utils/cn";
import { LuChevronUp } from "react-icons/lu";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { useState, useEffect, useContext } from "react";
import { CommonServiceContext } from "../../../services/common/commonService";
import Loader from "../../../components/Loader";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-6 w-6 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const FAQs = () => {
  const { faq, getFAQ, loading } = useContext(CommonServiceContext);

  const [open, setOpen] = useState(0);
  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  useEffect(() => {
    fetchFAQ();
  }, []);

  useEffect(() => {
    console.log(faq);
  }, [faq]);

  const fetchFAQ = async () => {
    await getFAQ();
  };

  return (
    <>
      {loading && <Loader />}
      <section id="faq" className="py-10 lg:py-20 mt-80">
        <div className="container">
          <div className="mb-10 flex items-end justify-between">
            <div className="mx-auto max-w-2xl text-center">
              <span className="rounded-md border border-primary bg-primary/20 px-3 py-1 text-xs font-medium uppercase tracking-wider text-primary">
                FAQ
              </span>
              <h2 className="my-4 text-3xl font-medium capitalize text-default-950">
                ხშირად დასმული კითხვები
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
            <div className="">
              <div className="w-full max-w-md mx-auto">
                {/* <Accordion open={open === 1} icon={<Icon id={1} open={open} />}>
                  <AccordionHeader onClick={() => handleOpen(1)}>
                    asdasda
                  </AccordionHeader>
                  <AccordionBody>asdasdasd</AccordionBody>
                </Accordion> */}
                {faq &&
                  faq.map((item, index) => (
                    <Accordion
                      key={index}
                      icon={<Icon id={1} open={open} />}
                      open={open === index + 1}
                    >
                      <AccordionHeader onClick={() => handleOpen(index + 1)}>
                        {item.name}
                      </AccordionHeader>
                      <AccordionBody style={{ whiteSpace: 'pre-wrap' }}>
                        {item.text}
                        </AccordionBody>
                    </Accordion>
                  ))}
                {/* {faqContent.map((faq, idx) => {
                  return (
                    <div
                      key={idx}
                      className={cn(
                        "hs-accordion overflow-hidden rounded-lg border border-default-200 bg-white dark:bg-default-50",
                        { active: idx === 0 }
                      )}
                    >
                      <button
                        className="hs-accordion-toggle inline-flex w-full items-center justify-between gap-x-3 px-6 py-4 text-left capitalize text-default-950 transition-all"
                        aria-controls="faq-accordion-1"
                      >
                        <h5 className="flex text-base font-medium">
                          {faq.title}
                        </h5>
                        <LuChevronUp className="lucide lucide-chevron-up size-4 transition-all duration-300 hs-accordion-active:-rotate-180" />
                      </button>
                      <div
                        className={cn(
                          "hs-accordion-content w-full overflow-hidden transition-[height] duration-300",
                          { hidden: idx != 0 }
                        )}
                        aria-labelledby="faq-1"
                      >
                        <div className="px-6 pb-4 pt-0">
                          <p className="text-sm">{faq.description}</p>
                        </div>
                      </div>
                    </div>
                  );
                })} */}
              </div>
            </div>
            <div className="relative">
              <div className="relative">
                <img src={web7} className="mx-auto rounded-xl" />
              </div>
              <div className="absolute inset-x-0 hidden lg:-bottom-14 lg:block">
                <img src={web6} className="h-full rounded-xl" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQs;
